/*
  free-shipping-celebrate.js
  Fires a confetti burst from the cart free-shipping bar the moment it reaches 100%.

  - Self-contained: no libraries, injects its own CSS.
  - Only fires on the TRANSITION to complete (not every re-render while already qualified).
  - Respects prefers-reduced-motion.

  Setup: upload to Assets, then load it once from cart-drawer.liquid:
    <script src="{{ 'free-shipping-celebrate.js' | asset_url }}" defer="defer"></script>
  The bar must carry `data-free-shipping-bar` and `data-fs-complete="true|false"`
  (already added in the updated cart-drawer.liquid).
*/
(function () {
  if (window.__freeShippingCelebrate) return;
  window.__freeShippingCelebrate = true;

  var COLORS = ['#e0533d', '#f4a9bd', '#f5d800', '#6cc5e8', '#3f9c35', '#a97fd0', '#ffffff'];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function injectStyles() {
    if (document.getElementById('fs-celebrate-styles')) return;
    var css =
      '.fs-confetti-layer{position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden;}' +
      '.fs-confetti{position:fixed;width:9px;height:14px;opacity:0;will-change:transform,opacity;' +
      'animation:fs-confetti-burst var(--dur,3000ms) cubic-bezier(.15,.6,.25,1) var(--delay,0ms) forwards;}' +
      '@keyframes fs-confetti-burst{' +
      '0%{transform:translate(0,0) rotate(0);opacity:0;}' +
      '6%{opacity:1;}' +
      '20%{transform:translate(calc(var(--tx) * .4), var(--pop)) rotate(calc(var(--rot) * .35));opacity:1;}' +
      '62%{opacity:1;}' +
      '100%{transform:translate(var(--tx), var(--ty)) rotate(var(--rot));opacity:0;}}' +
      '.cart-progress-bar.is-complete .bar-progress{animation:fs-bar-glow 1.6s ease-out;}' +
      '@keyframes fs-bar-glow{0%{box-shadow:0 0 0 0 rgba(63,156,53,0);}' +
      '30%{box-shadow:0 0 0 4px rgba(63,156,53,.35);}100%{box-shadow:0 0 0 0 rgba(63,156,53,0);}}' +
      '@media (prefers-reduced-motion: reduce){.fs-confetti{display:none;}' +
      '.cart-progress-bar.is-complete .bar-progress{animation:none;}}';
    var style = document.createElement('style');
    style.id = 'fs-celebrate-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function rand(min, max) { return Math.random() * (max - min) + min; }

  function celebrate(originEl) {
    if (reduceMotion) return;
    injectStyles();

    var rect = originEl ? originEl.getBoundingClientRect() : null;
    var onScreen = rect && rect.width > 0 && rect.top < window.innerHeight && rect.bottom > 0;
    var ox = onScreen ? rect.left + rect.width / 2 : window.innerWidth / 2;
    var oy = onScreen ? rect.top + rect.height / 2 : window.innerHeight / 3;

    var layer = document.createElement('div');
    layer.className = 'fs-confetti-layer';
    document.body.appendChild(layer);

    var spread = onScreen ? rect.width : 320;
    var count = Math.min(90, Math.max(55, Math.round(spread / 3.5)));

    for (var i = 0; i < count; i++) {
      var p = document.createElement('span');
      p.className = 'fs-confetti';
      p.style.left = (ox + rand(-spread / 2, spread / 2) * 0.3) + 'px';
      p.style.top = oy + 'px';
      p.style.background = COLORS[(Math.random() * COLORS.length) | 0];
      if (Math.random() < 0.5) p.style.borderRadius = '50%';
      p.style.setProperty('--tx', rand(-170, 170).toFixed(1) + 'px');
      p.style.setProperty('--ty', rand(90, 320).toFixed(1) + 'px');
      p.style.setProperty('--pop', rand(-150, -40).toFixed(1) + 'px');
      p.style.setProperty('--rot', rand(-540, 540).toFixed(0) + 'deg');
      p.style.setProperty('--dur', rand(2800, 4000).toFixed(0) + 'ms');
      p.style.setProperty('--delay', rand(0, 500).toFixed(0) + 'ms');
      layer.appendChild(p);
    }

    setTimeout(function () { layer.remove(); }, 4800);
  }

  function barEl() {
    return document.querySelector('#CartDrawer [data-free-shipping-bar], cart-drawer [data-free-shipping-bar]');
  }

  function isComplete(el) {
    return !!(el && (el.getAttribute('data-fs-complete') === 'true' || el.classList.contains('is-complete')));
  }

  // Last STABLE state, so we only fire when it flips from not-complete → complete.
  var wasComplete = isComplete(barEl());

  var debounce;
  function scheduleCheck() {
    clearTimeout(debounce);
    // Wait for the drawer's re-render + open animation to settle before reading/firing.
    debounce = setTimeout(function () {
      var el = barEl();
      var nowComplete = isComplete(el);
      if (nowComplete && !wasComplete) {
        celebrate(el);
      }
      wasComplete = nowComplete;
    }, 300);
  }

  var host = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
  if (host && 'MutationObserver' in window) {
    new MutationObserver(scheduleCheck).observe(host, { childList: true, subtree: true });
  }
})();